import React from 'react';

import {
  AsteriskIcon,
  CheckVerifiedIcon,
  ResourceIcon,
  UsersIcon,
  WorkBuildingIcon,
} from '../app/components/shared/icons';

export const detailsPages = [''];

export const newDetailsPages = [
  'member-company',
  'passion',
  'skill',
  'client',
  'person',
  'project',
  'industry',
  'discipline',
];

export const mapModels = [
  'member-company',
  'passion',
  'skill',
  'client',
  'person',
  'project',
  'industry',
  'collective',
  'community',
  'discipline',
];

export const mapModelForBehavioral = {
  person: 'people',
  industry: 'industries',
  'member-company': 'kyu_companies',
  passion: 'passions',
  skill: 'skills',
  project: 'projects',
  client: 'client_companies',
};

export const mapModelForBehavioralAction = {
  person: 'Person',
  industry: 'Industry',
  'member-company': 'Company',
  passion: 'Passion',
  skill: 'skill',
  project: 'Project',
  client: 'Company',
  discipline: 'Discipline',
};

export const sectionsToTitles = {
  at_a_glance: 'SPOTLIGHT',
  impact: `WORK`,
  people: 'TALENT',
  stories_and_highlights: 'RESOURCES',
};

export const companySectionsToIcons = {
  at_a_glance: <AsteriskIcon />,
  impact: <WorkBuildingIcon />,
  people: <UsersIcon />,
  stories_and_highlights: <ResourceIcon />,
};

export const clientSectionsToTitles = {
  snapshot: 'SPOTLIGHT',
  account_holders: 'ACCOUNT HOLDERS',
  expertise: 'WORK',
  people: 'TALENT',
  stories_and_highlights: 'RESOURCES',
};

export const clientSectionsToIcons = {
  snapshot: <AsteriskIcon />,
  expertise: <WorkBuildingIcon />,
  stories_and_highlights: <ResourceIcon />,
  people: <UsersIcon />,
  account_holders: <CheckVerifiedIcon />,
};

export const industrySectionsToTitles = {
  snapshot: 'SPOTLIGHT',
  expertise: 'WORK',
  people: 'TALENT',
  stories_and_highlights: 'RESOURCES',
  account_holders: 'ACCOUNT HOLDERS',
};

export const industrySectionsToIcons = {
  snapshot: <AsteriskIcon />,
  expertise: <WorkBuildingIcon />,
  stories_and_highlights: <ResourceIcon />,
  people: <UsersIcon />,
  account_holders: <CheckVerifiedIcon />,
};

export const passionSectionsToTitles = {
  at_a_glance: 'SPOTLIGHT',
  people: 'TALENT',
  map_snippet: 'RESOURCES',
};

export const passionSectionsToIcons = {
  at_a_glance: <AsteriskIcon />,
  people: <UsersIcon />,
  map_snippet: <ResourceIcon />,
};

export const skillSectionsToTitles = {
  at_a_glance: 'SPOTLIGHT',
  people: 'TALENT',
  map_snippet: 'RESOURCES',
};

export const skillSectionsToIcons = {
  at_a_glance: <AsteriskIcon />,
  people: <UsersIcon />,
  map_snippet: <ResourceIcon />,
};

export const projectSectionsToTitles = {
  about: `DESCRIPTION`,
  impact: `NEWS + ASSETS`,
  people: `PROJECT TEAM`,
  projects: `RELATED PROJECTS`,
  map_snippet: 'NETWORK MAP',
};

export const disciplineSectionsToTitles = {
  common_ground: `SPOTLIGHT`,
  people: `TALENT`,
  map_snippet: 'RESOURCES',
};

export const disciplineSectionsToIcons = {
  common_ground: <AsteriskIcon />,
  people: <UsersIcon />,
  map_snippet: <ResourceIcon />,
};

export const newModelsToOld = {
  person: 'people',
  industry: 'industries',
  'member-company': 'kyu_companies',
  passion: 'passions',
  skill: 'skills',
  project: 'projects',
  client: 'client_companies',
  'people-group': 'people',
  'skills-passions': 'multiple',
  discipline: 'discipline',
};

export const oldModelsToNew = {
  people: 'person',
  passions: 'passion',
  industries: 'industry',
  kyu_companies: 'member-company',
  partner_companies: 'member-company',
  member_companies: 'member-company',
  client_companies: 'client',
  companies: 'client',
  projects: 'project',
  skills: 'skill',
  communities: 'community',
  kyu: 'kyu',
  clients: 'client',
  languages: 'language',
  cities: 'city',
  articles: 'articles',
  tools: 'tools',
  convenings: 'convening',
  disciplines: 'discipline',
  locations: 'location',
  roles: 'role',
  levels: 'level',
  resources: 'resource',
};

export const oldModelsToNewSelectedCriteria = {
  people: 'person',
  passions: 'passion',
  industries: 'industry',
  kyu_companies: 'company',
  partner_companies: 'company',
  member_companies: 'company',
  companies: 'company',
  client_companies: 'client',
  projects: 'project',
  skills: 'skill',
  communities: 'community',
  kyu: 'kyu',
  clients: 'client',
  languages: 'language',
  cities: 'city',
  articles: 'articles',
  tools: 'tools',
  convenings: 'convening',
  disciplines: 'discipline',
  locations: 'location',
  roles: 'role',
  levels: 'level',
};

export const oldModelsToNewSelectedCriteriaTooltipLabel = {
  people: 'person',
  passions: 'passion',
  industries: 'industry',
  kyu_companies: 'company',
  partner_companies: 'company',
  member_companies: 'company',
  companies: 'company',
  client_companies: 'client',
  projects: 'project',
  skills: 'skill',
  communities: 'community',
  kyu: 'kyu',
  clients: 'client',
  languages: 'language',
  cities: 'city',
  articles: 'articles',
  tools: 'tools',
  convenings: 'convening',
  disciplines: 'discipline',
  locations: 'location',
  roles: 'role',
  levels: 'level',
};

export const newModelsToOldModels = {
  person: 'people',
  passion: 'passions',
  industry: 'industries',
  company: 'companies',
  project: 'projects',
  skill: 'skills',
  community: 'communities',
  kyu: 'kyu',
  client: 'clients',
  language: 'languages',
  city: 'cities',
  articles: 'articles',
  tools: 'tools',
  convening: 'convenings',
  discipline: 'disciplines',
  location: 'locations',
  role: 'roles',
  level: 'levels',
};

export const newSelectedCriteriaToOldModels = {
  person: 'people',
  passion: 'passions',
  industry: 'industries',
  'member-company': 'companies',
  company: 'companies',
  client: 'client_companies',
  project: 'projects',
  skill: 'skills',
  community: 'communities',
  kyu: 'kyu',
  language: 'languages',
  city: 'cities',
  article: 'articles',
  tool: 'tools',
  convening: 'convenings',
  discipline: 'disciplines',
  location: 'locations',
  role: 'roles',
  level: 'levels',
};

export const oldModelsToNewSelectedCriteriaLabel = {
  people: 'Person',
  passions: 'Passion',
  industries: 'Industry',
  kyu_companies: 'Company',
  partner_companies: 'Company',
  member_companies: 'Company',
  companies: 'Company',
  client_companies: 'Client',
  projects: 'Project',
  skills: 'Skill',
  communities: 'Community',
  kyu: 'kyu',
  clients: 'Client',
  languages: 'Language',
  cities: 'City',
  articles: 'Articles',
  tools: 'Tools',
  convenings: 'Convening',
  disciplines: 'Discipline',
  locations: 'Location',
  roles: 'Role',
  levels: 'Level',
};

export const pageTitles = {
  client: 'Client',
  industry: 'Industry',
  'member-company': 'Company',
  passion: 'Passion',
  'people-group': 'Results - Known Group',
  person: 'Person',
  project: 'Project',
  skill: 'Skill',
  discipline: 'Discipline',
  'skills-passions': 'Results - Skills x Passions',
};

export const pluralModelToSingular = {
  clients: 'client',
  companies: 'company',
};

export const modelToScopeType = {
  client: 'client',
  'member-company': 'company',
  industry: 'industry',
  passion: 'passion',
  skill: 'skill',
  discipline: 'discipline',
};

export const behavioralObjectTypeCorrectionMap = new Map<string, string>([
  ['member_companies', 'companies'],
  ['clients', 'companies'],
  ['client', 'companies'],
]);
